var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQaIconCmu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_849_1820)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.2026 80H19.4634C8.91736 80 0.333008 71.4157 0.333008 60.8696V19.1304C0.333008 8.58435 8.91736 0 19.4634 0H61.2026C71.7487 0 80.333 8.58435 80.333 19.1304V60.8696C80.333 71.4157 71.7487 80 61.2026 80ZM19.4634 3.47826C10.8304 3.47826 3.81127 10.4974 3.81127 19.1304V60.8696C3.81127 69.5026 10.8304 76.5217 19.4634 76.5217H61.2026C69.8356 76.5217 76.8548 69.5026 76.8548 60.8696V19.1304C76.8548 10.4974 69.8356 3.47826 61.2026 3.47826H19.4634Z",
    fill: "url(#paint0_linear_849_1820)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_849_1820",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 78,
    height: 78
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1562 1.37695H18.504C9.22944 1.37695 1.71094 8.89546 1.71094 18.17V61.8222C1.71094 71.0967 9.22944 78.6152 18.504 78.6152H62.1562C71.4307 78.6152 78.9492 71.0967 78.9492 61.8222V18.17C78.9492 8.89546 71.4307 1.37695 62.1562 1.37695Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_849_1820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.4427 39.8198C43.6931 40.4528 43.8253 41.1415 43.8253 41.865C43.8253 44.418 42.1835 46.498 40.1731 46.498C38.1627 46.498 36.5209 44.418 36.5209 41.865C36.5209 41.1415 36.6531 40.4528 36.9035 39.8198H43.4496M44.6531 37.8232H35.7001C34.9627 38.9432 34.5244 40.3415 34.5244 41.865C34.5244 45.5241 37.0566 48.4945 40.1731 48.4945C43.2896 48.4945 45.8218 45.5241 45.8218 41.865C45.8218 40.3415 45.3835 38.9432 44.6462 37.8232H44.6531Z",
    fill: "url(#paint1_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2549 38.4419H37.2236V37.0298C37.2236 35.3671 38.5732 34.0176 40.2358 34.0176C41.8984 34.0176 43.248 35.3671 43.248 37.0298V38.4419H43.2549Z",
    fill: "url(#paint2_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1752 38.3174H39.1787V47.9104H41.1752V38.3174Z",
    fill: "url(#paint3_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6934 39.2077C35.436 39.2077 35.1855 39.1103 34.9907 38.9155L33.1125 37.0372C32.9247 36.8494 32.8203 36.599 32.8203 36.3346V34.032C32.8203 33.4824 33.2655 33.0303 33.8221 33.0303C34.3786 33.0303 34.8238 33.4755 34.8238 34.032V35.9242L36.4099 37.5103C36.7994 37.8998 36.7994 38.5329 36.4099 38.9224C36.2151 39.1172 35.9577 39.2146 35.7003 39.2146L35.6934 39.2077Z",
    fill: "url(#paint4_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7508 39.2078C44.4934 39.2078 44.2429 39.1104 44.0412 38.9156C43.6516 38.526 43.6516 37.893 44.0412 37.5034L45.6273 35.9174V34.0252C45.6273 33.4756 46.0725 33.0234 46.629 33.0234C47.1855 33.0234 47.6308 33.4687 47.6308 34.0252V36.3278C47.6308 36.5921 47.5264 36.8495 47.3386 37.0304L45.4603 38.9087C45.2655 39.1034 45.0082 39.2008 44.7577 39.2008L44.7508 39.2078Z",
    fill: "url(#paint5_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7654 49.6908C33.2158 49.6908 32.7637 49.2456 32.7637 48.6891V46.3865C32.7637 46.0804 32.9028 45.7952 33.1393 45.6074L34.8924 44.2091C35.3237 43.8682 35.9498 43.9378 36.2976 44.3691C36.6385 44.8004 36.5689 45.4265 36.1376 45.7743L34.7602 46.8735V48.6961C34.7602 49.2456 34.315 49.6978 33.7585 49.6978L33.7654 49.6908Z",
    fill: "url(#paint6_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5791 49.6909C46.0295 49.6909 45.5773 49.2456 45.5773 48.6891V46.8456L44.2417 45.6909C43.8243 45.3291 43.7756 44.703 44.1373 44.2856C44.4991 43.8682 45.1321 43.8196 45.5426 44.1813L47.226 45.6352C47.4487 45.823 47.5739 46.1013 47.5739 46.3935V48.6961C47.5739 49.2456 47.1286 49.6978 46.5721 49.6978L46.5791 49.6909Z",
    fill: "url(#paint7_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0963 44.2294C32.0268 44.2294 31.9642 44.2225 31.8946 44.2086C31.352 44.0973 31.0042 43.5686 31.1155 43.0329L31.5746 40.779C31.672 40.3199 32.0685 39.986 32.5415 39.979L34.7329 39.9512C35.2963 39.9512 35.7346 40.3825 35.7485 40.939C35.7555 41.4886 35.3172 41.9407 34.7676 41.9547L33.3763 41.9755L33.0772 43.4433C32.9798 43.9164 32.5624 44.2433 32.1033 44.2433L32.0963 44.2294Z",
    fill: "url(#paint8_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3125 44.2297C47.8464 44.2297 47.429 43.9027 47.3386 43.4297L47.0395 41.9618L45.6482 41.941C45.0986 41.934 44.6534 41.4818 44.6673 40.9253C44.6743 40.3758 45.1264 39.9375 45.683 39.9375L47.8743 39.9653C48.3404 39.9653 48.7438 40.3062 48.8412 40.7653L49.3004 43.0192C49.4117 43.5618 49.0638 44.0905 48.5212 44.1949C48.4517 44.2088 48.3891 44.2158 48.3195 44.2158L48.3125 44.2297Z",
    fill: "url(#paint9_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0514 35.9793C41.7384 35.9793 41.4323 35.8333 41.2375 35.5619C40.9175 35.1167 41.0218 34.4906 41.4671 34.1706C41.5853 34.0872 41.7453 33.8646 41.794 33.5306C41.8427 33.1898 41.794 32.6472 41.2792 31.9863C40.9453 31.548 41.0218 30.9219 41.4601 30.588C41.8984 30.2472 42.5244 30.3306 42.8584 30.7689C43.5957 31.7219 43.9157 32.8072 43.7627 33.8298C43.6444 34.6506 43.227 35.3672 42.6149 35.8054C42.441 35.9306 42.2392 35.9933 42.0375 35.9933L42.0514 35.9793Z",
    fill: "url(#paint10_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4408 35.9796C38.2391 35.9796 38.0374 35.9169 37.8635 35.7917C37.2582 35.3604 36.8408 34.6369 36.7156 33.8161C36.5626 32.7935 36.8895 31.7082 37.62 30.7552C37.9539 30.3169 38.5869 30.2404 39.0182 30.5743C39.4565 30.9082 39.533 31.5413 39.1991 31.9726C38.6843 32.6404 38.6356 33.183 38.6843 33.5169C38.733 33.8509 38.893 34.0665 39.0113 34.1569C39.4634 34.4769 39.5608 35.103 39.2408 35.5482C39.0461 35.8195 38.74 35.9656 38.4269 35.9656L38.4408 35.9796Z",
    fill: "url(#paint11_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4583 40.9877C24.507 39.492 24.7852 38.0172 25.2792 36.619C25.5992 35.7146 25.1261 34.7198 24.2218 34.3998C23.3174 34.0798 22.3226 34.5529 22.0026 35.4572C21.3835 37.1964 21.0426 39.019 20.98 40.8764C20.8687 44.1598 21.6618 47.3946 23.2687 50.2398C23.5887 50.8033 24.18 51.1233 24.7852 51.1233C25.0774 51.1233 25.3696 51.0538 25.6409 50.9007C26.4757 50.4277 26.7748 49.3703 26.3018 48.5285C25.0078 46.2398 24.3748 43.6311 24.4583 40.9877Z",
    fill: "url(#paint12_linear_849_1820)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9627 76.5218L67.2201 56.7792C66.5662 56.1253 65.4114 56.1253 64.7575 56.7792L63.7279 57.8088L62.0445 56.1253C65.3558 51.6314 67.3106 46.0801 67.3106 40.0836C67.3106 25.127 55.1436 12.9531 40.1801 12.9531C25.2166 12.9531 13.0566 25.1201 13.0566 40.0836C13.0566 55.047 25.2236 67.214 40.1871 67.214C46.2045 67.214 51.7697 65.2453 56.2706 61.9131L57.9471 63.5896L57.1053 64.4314C56.4236 65.1131 56.4236 66.2123 57.1053 66.894L76.8479 86.6366C78.1975 87.9862 79.9923 88.7305 81.9053 88.7305C83.8184 88.7305 85.6132 87.9862 86.9627 86.6366C88.3123 85.287 89.0566 83.4922 89.0566 81.5792C89.0566 79.6662 88.3123 77.8714 86.9627 76.5218ZM16.5349 40.0836C16.5349 27.0401 27.1436 16.4314 40.1871 16.4314C53.2306 16.4314 63.8392 27.0401 63.8392 40.0836C63.8392 53.127 53.2306 63.7357 40.1871 63.7357C27.1436 63.7357 16.5349 53.127 16.5349 40.0836ZM58.9349 59.6592C59.2271 59.3809 59.5123 59.0888 59.7975 58.7966L61.2723 60.2714L60.4097 61.134L58.9349 59.6592ZM65.9888 60.4662L68.521 62.9983L63.3245 68.1949L60.7923 65.6627L65.9888 60.4662ZM84.5071 84.1809C83.8114 84.8766 82.8932 85.2592 81.9123 85.2592C80.9314 85.2592 80.0062 84.8766 79.3175 84.1809L65.794 70.6575L70.9906 65.4609L84.514 78.9844C85.2097 79.6801 85.5923 80.5983 85.5923 81.5792C85.5923 82.5601 85.2097 83.4853 84.514 84.174L84.5071 84.1809Z",
    fill: "url(#paint13_linear_849_1820)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_849_1820",
    x: 0.333008,
    y: 0,
    width: 80,
    height: 84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_849_1820"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_849_1820",
    x1: 40.333,
    y1: 0,
    x2: 40.333,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_849_1820",
    x1: 40.1731,
    y1: 37.8232,
    x2: 40.1731,
    y2: 48.4945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_849_1820",
    x1: 40.2393,
    y1: 34.0176,
    x2: 40.2393,
    y2: 38.4419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_849_1820",
    x1: 40.177,
    y1: 38.3174,
    x2: 40.177,
    y2: 47.9104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_849_1820",
    x1: 34.7612,
    y1: 33.0303,
    x2: 34.7612,
    y2: 39.2146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_849_1820",
    x1: 45.6899,
    y1: 33.0234,
    x2: 45.6899,
    y2: 39.2078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_849_1820",
    x1: 34.6386,
    y1: 43.9932,
    x2: 34.6386,
    y2: 49.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_849_1820",
    x1: 45.7342,
    y1: 43.9385,
    x2: 45.7342,
    y2: 49.6978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_849_1820",
    x1: 33.4217,
    y1: 39.9512,
    x2: 33.4217,
    y2: 44.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_849_1820",
    x1: 46.994,
    y1: 39.9375,
    x2: 46.994,
    y2: 44.2297,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_849_1820",
    x1: 42.4259,
    y1: 30.3779,
    x2: 42.4259,
    y2: 35.9933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_849_1820",
    x1: 38.0536,
    y1: 30.3672,
    x2: 38.0536,
    y2: 35.9796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_849_1820",
    x1: 23.7481,
    y1: 34.2998,
    x2: 23.7481,
    y2: 51.1233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_849_1820",
    x1: 51.0566,
    y1: 12.9531,
    x2: 51.0566,
    y2: 88.7305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E12426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695,
    stopColor: "#C61F20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B41214"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaIconCmu);
export default __webpack_public_path__ + "static/media/qa_icon_cmu.73db36387c512eaa71ee29f7983400f0.svg";
export { ForwardRef as ReactComponent };